import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import classNames from 'classnames'

import Modal from '../../../common/Modal'
import CancelButton from '../../../common/buttons/CancelButton'
import SubmitButton from '../../../common/buttons/SubmitButton'
import { ReactComponent as ClapIcon } from '../../../../assets/images/common/icons/clap-icon.svg'
import { hasSeenWelcome, isFirstLogin, markWelcomeSeen } from '../../../../utility/welcomeModal'

import classes from './CoachWelcomeModal.module.scss'

const CoachWelcomeModal = () => {
  const navigate = useNavigate()
  const user = useSelector(state => state.user.current_user)

  const [isOpen, setIsOpen] = useState(() => isFirstLogin(user) && !hasSeenWelcome(user.id))

  const handleClose = () => {
    markWelcomeSeen(user.id)
    setIsOpen(false)
    navigate('/dashboard')
  }

  return (
    <Modal isOpen={isOpen} onClose={handleClose} className={classes.welcomeModalContent}>
      <div className={classNames(classes.welcomeModal, 'd-flex flex-column align-items-center text-center')}>
        <div className={classNames(classes.iconCircle, 'd-flex align-items-center justify-content-center')}>
          <ClapIcon className={classes.clapIcon} aria-hidden='true' />
        </div>

        <h2 className={classNames(classes.modalTitle, 'mt-4 mb-2')}>Welcome to Operation 36</h2>
        <p className={classNames(classes.modalSubtitle, 'mb-5')}>
          Your coach account is ready. Complete your onboarding to set up your Op 36 program and start enrolling golfers.
        </p>

        <div className='row w-100'>
          <div className='col-6'>
            <SubmitButton id='coach-welcome-start-onboarding' type='button' buttonMessage='Start Onboarding' onClick={handleClose} noTopMargin />
          </div>

          <div className='col-6'>
            <CancelButton onClick={handleClose} buttonMessage='Go to Dashboard' />
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default CoachWelcomeModal
